// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__HHhju"};